import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'

const data = {
  question:
    'It is important to be an informed consumer. Which of the following tools can you use to critically monitor your social media accounts?',
  inputType: 'radio',
  options: [
    {
      label: 'View videos and posts showing teens vaping.',
    },
    {
      label: 'Follow influencers that promote vaping products.',
    },
    {
      label: 'Interact with posts about products for vaping and e-cigarettes.',
    },
    {
      label: 'Report posts you are not interested in, including e-cigarettes.',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[3].label,
}

const feedback = {
  success: {
    title: 'That’s right!',
    body:
      'Reporting posts for products you are not interested in is one way to critically monitor your social media accounts.',
  },
  error: {
    title: 'Not quite.',
    body:
      'Reporting posts for products you are not interested in is one way to critically monitor your social media accounts.  You will learn more about this in the module.',
  },
}

export default {
  title: 'Question 5',
  path: '/prepare/question-5',
  content: (
    <Fragment>
      <Intro
        title="Question 5"
        direction={'Select the item that best completes the statement.'}
      />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/Question5.js